/**
 * Extracts URL parameter
 *
 * @param {string} paramName URL param name
 * @returns {string} URL param.
 */
export default (paramName) => (new URLSearchParams(window.location.search)).get(paramName);
